module.exports = __webpack_public_path__ + "img/berekening-voorbeeld-fr-be.ef134026.png";